import React from 'react';
import { get, isEqual } from 'lodash';

// React view component to render
import { authFlowMemberVerificationHipaaAuthorization as AuthFlowMemberVerificationHipaaAuthorizationView } from 'ui/views/widgets/authFlowMemberVerificationHipaaAuthorization';
import { AuthFlowMemberVerificationHipaaAuthorizationService } from 'services/authFlowMemberVerificationHipaaAuthorization';
import { SERVICE_RESPONSE_STATUS } from 'constants/common';

/**
 * @type {class}
 * @desc A React container/smart component to render a React presentational/dumb component (view).
 * @example
 * import { AuthFlowMemberVerificationHipaaAuthorization } from 'ui/containers/AuthFlowMemberVerificationHipaaAuthorization';
 *
 * // render
 * <AuthFlowMemberVerificationHipaaAuthorization propName='propValue'/>
 */
export class AuthFlowMemberVerificationHipaaAuthorization extends React.Component {
    
    /**
     * @param {object} props - props
     */
    constructor( props ) {
        super( props );

        // component state
        this.state = {
            isFetching: true,
            networkStatus: undefined,
            networkError: undefined,
            componentData: undefined,
        };

        // create service instance
        this.authFlowMemberVerificationHipaaAuthorizationService = new AuthFlowMemberVerificationHipaaAuthorizationService();
        
        // start component data fetch
        this.fetchComponentData();
    }

    /*********************************************/

    /**
     * @desc Fetch component response.
     */
    async fetchComponentData() {
        log.debug( 'AuthFlowMemberVerificationHipaaAuthorization.fetchComponentData()' );

        // cancel ongoing request
        this.authFlowMemberVerificationHipaaAuthorizationService.cancel();

        // get status and service data
        const { status, data } = await this.authFlowMemberVerificationHipaaAuthorizationService.fetchComponentData( {
            url: this.props.widget.url,
            data: {
                context: {
                    memberId: this.props.memberId,
                    patientId: this.props.patientId,
                }
            }
        } );

        // check if response status was success
        if( SERVICE_RESPONSE_STATUS.SUCCESS !== status ) {
            this.setState( {
                isFetching: false,
                networkStatus: SERVICE_RESPONSE_STATUS.FAILURE,
                networkError: data,
            } );
        } else {
            this.setState( {
                isFetching: false,
                networkStatus: SERVICE_RESPONSE_STATUS.SUCCESS,
                componentData: data,
            } );
        }
    }

    UNSAFE_componentWillReceiveProps( nextProps ) {
        log.debug( 'AuthFlowMemberVerificationHipaaAuthorization.UNSAFE_componentWillReceiveProps()' );

        if( ! isEqual( nextProps.memberId, this.props.memberId ) ) {

            this.setState( { isFetching: true }, () => {
                this.fetchComponentData();
            } );
            
        }
    }

    /*********************************************/

    /**
     * @desc When component unmounts, cleanup resouces.
     */
    componentWillUnmount() {
        this.authFlowMemberVerificationHipaaAuthorizationService.cancel(); // cancel ongoing requests
    }

    /*********************************************/

    /**
     * @desc Render a React view component
     */
    render() {
        return (
            <AuthFlowMemberVerificationHipaaAuthorizationView
                isFetching={ this.state.isFetching }
                networkStatus={ this.state.networkStatus }
                componentData={ get( this.state, 'componentData', {} ) }
                networkError={ this.state.networkError }
                errorViewConfig = { { padding: 'small' } }
            />
        );
    }
}

// set display name
AuthFlowMemberVerificationHipaaAuthorization.displayName = 'AuthFlowMemberVerificationHipaaAuthorization';

// set default props
AuthFlowMemberVerificationHipaaAuthorization.defaultProps = {};

// prop types
AuthFlowMemberVerificationHipaaAuthorization.propTypes = {};
